var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"board-card",class:{
    'user-can-drag': !_vm.disabled && _vm.issue.id,
    'is-disabled': _vm.disabled || !_vm.issue.id,
    'is-active': _vm.issueDetailVisible,
  },attrs:{"index":_vm.index,"data-issue-id":_vm.issue.id},on:{"mousedown":_vm.mouseDown,"mousemove":_vm.mouseMove,"mouseup":function($event){_vm.showIssue($event);}}},[_c('issue-card-inner',{attrs:{"list":_vm.list,"issue":_vm.issue,"issue-link-base":_vm.issueLinkBase,"group-id":_vm.groupId,"root-path":_vm.rootPath,"update-filters":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }